export default __webpack_public_path__ + "static/media/giftbox.23d825ba.png";